import React from "react";
import LoadingIndicator from "canvas-core-react/lib/LoadingIndicator";

import "./LoadingIframe.scss";

export const LoadingIframe = () => {
    return (
        <LoadingIndicator
            className="biometric__center-loading-indicator"
            size="extraLarge"
        />
    );
};
